export enum DropdownModules {
  CUSTOMERS = 'customers',
  DICTIONARIES = 'dictionaries',
  EMPLOYEES = 'employees',
  COMPETENCE_DOMAINS = 'competence-domains',
  ALL_COMPETENCE_DOMAINS = 'all-competence-domains',
  ALL_COMPETENCE_DOMAINS_FILTERED = 'all-competence-domains-filtered',
  MY_PROJECTS = 'my-projects',
  PROJECTS = 'projects',
  PROJECTS_ALL = 'projects-all',
  PROJECTS_AFFECTED_BY_TENANT = 'projects-affected-by-tenant',
  PARENT_PROJECTS = 'parent-projects',
  CSAT_PROJECTS = 'csat-projects',
  PROJECT_CATEGORIES = 'project-categories',
  TITLE_DOMAINS = 'title-domains',
  TITLE_DOMAINS_FILTERED = 'title-domains-filtered',
  GRADES = 'grades',
  COST_CENTERS = 'cost-centers',
  COST_CENTERS_ALL = 'cost-centers-all',
  USERS = 'users',
  SOFT_SKILLS = 'soft-skills',
  MANAGERS = 'managers',
  ENGAGEMENT_MANAGERS = 'engagement-managers',
  ASSIGNED_MANAGERS = 'assigned-managers',
  PARTNER_USERS = 'managers',
  CONSULTANTS = 'consultants',
  CONSULTANTS_TENANT_FILTERED = 'consultants-tenant-filtered',
  USERS_TENANT_FILTERED = 'users-tenant-filtered',
  USERS_ACROSS_ALL_PARTNERS = 'users-across-all-partners',
  CERTIFICATES = 'certificates',
  SKILLS = 'skills',
  SPECIALIZATIONS = 'specializations',
  COUNTRIES_FILTERED = 'holidays-countries-filtered',
  CAREER_PLANS_ACTIVE = 'career_plans-active',
  CDP_PACKAGES_ACTIVE = 'cdp-packages-active',
  CDP_PACKAGE_ITEMS_ACTIVE = 'cdp-package-items-active',
  CDP_GOALS = 'cdp-goals',

  PROJECT_ROLES_ACTIVE = 'project-roles-active',
  DELIVERABLES = 'deliverables',
  TIMEZONES = 'timezones',
  ALLOCATIONS = 'allocations',

  OFFERINGS_ALL = 'offerings-all',
  OFFERINGS_ACTIVE = 'offerings',
  HUBSPOT_CUSTOMERS = 'hubspot-customers',
  HUBSPOT_PIPELINES = 'hubspot-pipelines',
  HUBSPOT_STAGES = 'hubspot-stages',
  HUBSPOT_COUNTRIES = 'hubspot-countries',
  HUBSPOT_DEALS = 'hubspot-deals',

  // SO => Static objects:relatedCollection:dictionary
  SO_REL_KNOWLEDGE_SHARING_TYPES = 'so:knowledgeSharing:knowledgeSharingType',
  SO_REL_PROJECT_TYPES = 'so:projectModule:projectTypes',
  SO_REL_EMPLOYEE_LANGUAGES = 'so:employeeLanguages:languages',
  SO_REL_EMPLOYEE_LANGUAGE_LEVELS = 'so:employeeLanguages:languageLevels',
  SO_REL_ALLOCATION_MODULE_LOAD_TYPES = 'so:allocationModule:loadTypes',
  SO_REL_ALLOCATION_MODULE_RECALCULATION_TYPES = 'so:allocationModule:recalculationTypes',
  SO_REL_PROJECT_EQ_CURRENCIES = 'so:projectEquipments:currencies',
  SO_REL_PROJECT_MODULE_TYPES = 'so:projectModule:projectTypes',
  SO_REL_PROJECT_MODULE_ESTIMATE_TYPES = 'so:projectModule:estimateTypes',
  SO_REL_PROJECT_MODULE_STATUSES = 'so:projectModule:projectStatuses',
  SO_REL_PROJECT_MODULE_INVOICING_TYPE = 'so:projectModule:invoicingTypes',
  SO_REL_PROJECT_MODULE_DELIVERY_CATEGORY = 'so:projectModule:deliveryCategories',
  SO_REL_PROJECT_MODULE_CSAT_SCHEDULES = 'so:projectModule:csatSchedules',
  SO_REL_PROJECT_CUSTOMERS_COUNTRIES = 'so:projectCustomers:countries',
  SO_REL_PROJECT_CUSTOMERS_INDUSTRIES = 'so:projectCustomers:customerIndustries',
  SO_REL_PROJECT_CUSTOMERS_SIZES = 'so:projectCustomers:customerSizes',
  SO_REL_PROJECT_CUSTOMERS_RESOURCING_RESTRICTIONS = 'so:projectCustomers:resourcingRestrictions',
  SO_REL_PROJECT_CUSTOMERS_STATUSES = 'so:projectCustomers:customerStatuses',
  SO_REL_COST_CENTERS_STATUSES = 'so:cost-centers:costCenterStatuses',
  SO_REL_EMPLOYEE_EMPLOYMENT_TYPE = 'so:employees:employmentType',
  SO_REL_PROJECT_EXPERIENCES_ROLES = 'so:projectExperiences:role',
  SO_REL_PROJECT_EXPERIENCES_ENABLER_FACTOR = 'so:projectExperiences:enabler_factor',
  SO_REL_PROJECT_EXPERIENCES_SIZE_OF_DELIVERABLE = 'so:projectExperiences:size_of_deliverable',
  SO_REL_PROJECT_EXPERIENCES_CUSTOMER_SIZE = 'so:projectExperiences:customer_size',
  SO_REL_PROJECT_EXPERIENCES_INDUSTRY = 'so:projectExperiences:industry',
  SO_REL_EMPLOYEE_GRADE = 'so:employee:grades',
  SO_REL_EMPLOYEE_SKILL_LEVELS = 'so:employee:skill_levels',
  SO_REL_NATIONAL_HOLIDAY_TYPE = 'so:nationalHolidays:holidayTypes',
  SO_REL_CSAT_STATUSES = 'so:csats:csatStatus',
  SO_REL_CSAT_TYPES = 'so:csats:csatType',
  SO_REL_DEVIATION_STATUSES = 'so:allocation-deviations:deviationStatus',
  SO_REL_DATE_FORMATS = 'so:users:dateFormats',
  SO_REL_TIME_FORMATS = 'so:users:timeFormats',
  SO_REL_CAREER_PLAN_STATUSES = 'so:career-plans:status',
  SO_REL_PROJECT_ROLE_STATUSES = 'so:project-roles:status',
  SO_REL_TITLE_STATUSES = 'so:project-roles:status',
  SO_REL_TASK_STATUSES = 'so:tasks:taskStatus',
  SO_REL_ORDER_HANDLER_CATEGORIES = 'so:projects:orderHandlerCategories',
  SO_REL_CDP_ARTIFACT_TYPES = 'so:cdp-package-items:artifactTypes',
}

export interface SelectableEvent {
  text: string;
}

export interface DropdownItem<T> {
  item: T;
  isSelected: boolean;
}
